import { Check } from "lucide-react";

export default function ProgressSteps({ steps, current }) {
  const pct = ((current + 1) / steps.length) * 100;
  return (
    <div data-testid="progress-steps" className="mb-10">
      <div className="rx-progress-bar mb-6">
        <div style={{ width: `${pct}%` }} />
      </div>
      <div className="grid grid-cols-3 text-center">
        {steps.map((label, i) => {
          const state = i < current ? "done" : i === current ? "active" : "pending";
          return (
            <div key={label} className="flex flex-col items-center gap-2">
              <div className={`rx-step-circle ${state}`} data-testid={`step-circle-${i + 1}`}>
                {state === "done" ? <Check className="w-4 h-4" /> : i + 1}
              </div>
              <div
                className={`text-sm ${state === "active" ? "text-blue-600 font-semibold" : "text-slate-500"}`}
              >
                {label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
